import { Component, OnInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CanComponentDeactivate, CanDeactivateGuardService } from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

import { AssessmentSummary, DateUtility, SINGLE_ROW_HEADER, DOUBLE_ROW_HEADER, RequestVO, Task, WpReferral, WpPerson } from '../shared';
import {
  CommonUtility, ServerConstantsService, DataService, DELETE_BTN, AUDIT_BTN,
  AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, AgGridUtility
} from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import { CurrencyEditorComponent } from '../shared/components/currency.component';
import { BootstrapDatePickerComponent } from '../shared/components/ng-date-picker.component';
import { TextEditor50Component } from '../shared/components/text-editor-max-len-50.component';
import { PersonProvider } from '../shared/model/PersonProvider';
import { EmploymentHistory } from '../employment-summary/employment-summary.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-work-history',
  templateUrl: './work-history.component.html',
  styleUrls: ['./work-history.component.scss'],
})
export class WorkHistoryComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText: ElementRef;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;
  isDisabled = false;
  tabIndex: any = '-1';
  isPrior: boolean;
  personId;
  referralId = '';
  isCurrentEnrollment:Boolean = false;
  experiencesSw: String;
  empSecuritySw: String;
  employmentSw: String;
  show = false;
  workHistory: WorkHistory[] = [];
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  frameworkComponents;

  jobStatusDescJson: any;
  jobStatusDescReverseJson: any;
  reasonLeavingJobDescJson: any;
  reasonLeavingJobDescReverseJson: any;

  columnDefs: any;
  auditColumnDefs: any;
  testContext: any;
  jobStatusArray = [];
  reasonLeavingArray = [];
  removedWorkHistory: WorkHistory[] = [];
  userFullName;
  rowSelection;
  assessmentId;
  context;
  gridApi;
  gridanswerApi;
  gridColumnApi;
  assessment: AssessmentSummary;
  userActionNotificationsMap: any;
  components;
  defaultColDef;
  editType;

  serverConstants: any;
  sharedData: any;

  serviceCountyForPerson: number;
  providerForPerson: number;
  personProvider: PersonProvider;

  employmenTask: Task;

  employmentHistory = [];
  answersColumnDefs;

  validationError = [];
  showError = false;

  isShowStyle = false;
  isChangeDetected = false;
  isWorkHistoryLoded = false;
  readOnly = false;
  tabToNextCell: any;

  constructor(

    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService,
    private datePipe:DatePipe
  ) {
    this.serverConstants = serverConstantsService.getConstants();


    if (this.dataService.getSharedDataObject().get('ASMNT') === undefined) {
      this.router.navigate(['/task']);
    }

  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    this.readOnly = this.dataService.getSharedDataObject().get("ASMNT").innerNavPages.find(x => x.pageId === 'ASMWH').readOnly;
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    const jobStatusDesc = this.data.getValueFromSharedDataMap('JobStatusDesc');
    jobStatusDesc.forEach(element => {
      this.jobStatusArray.push(element.name);
    });
    this.jobStatusDescJson = this.commonUtil.createNativeMapFromList(jobStatusDesc);
    this.jobStatusDescReverseJson = this.commonUtil.createReverseNativeMapFromList(jobStatusDesc);


    const reasonLeavingJobDesc = this.data.getValueFromSharedDataMap('ReasonLeavingJobDesc');
    reasonLeavingJobDesc.forEach(element => {
      this.reasonLeavingArray.push(element.name);
    });
    this.reasonLeavingJobDescJson = this.commonUtil.createNativeMapFromList(reasonLeavingJobDesc);
    this.reasonLeavingJobDescReverseJson = this.commonUtil.createReverseNativeMapFromList(reasonLeavingJobDesc);


    // Shared object access to get personId and assessmentId
    this.sharedData = this.dataService.getSharedDataObject();

    if (this.sharedData.get('assessmentId') !== null && this.sharedData.get('assessmentId') !== undefined) {
      this.assessmentId = Number(this.sharedData.get('assessmentId'));
    }
    if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
      this.personId = Number(this.sharedData.get('wpPersonId'));
    }

    this.referralId = this.sharedData.get('referralId');
    this.personProvider = this.sharedData.get('personProvider');
    this.serviceCountyForPerson = this.personProvider.id.serviceCounty;
    this.providerForPerson = this.personProvider.id.providerId;



    this.getColumnDefinitions();
    this.getColumnDefinitionsAnswer();


    // Audit
    this.getAuditColumnDefs();

    if (this.assessmentId > 0) {
      const request = new RequestLoad(this.assessmentId);
      this.load(request);

    }

    (this.sharedData.get('personProvider').conversionStat === 'CM') ? this.loadAriesData() : this.loadAnswerData();

    if (this.sharedData.get('selectedEnrollmentEndDt') !== null && this.sharedData.get('selectedEnrollmentEndDt') !== undefined
    && this.sharedData.get('selectedEnrollmentEndDt') !== "Current") {
      this.isCurrentEnrollment = false;
    } else {
      this.isCurrentEnrollment = true
    }

  }



  radioEmpSecurity() {
    // if (this.empSecuritySw === 'Y') {
    //   this.isTests = true;
    // } else {
    //   this.isTests = false;
    // }
  }
  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  radioExperience() {
    if (this.experiencesSw === 'Y') {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  radioEmployment() {
    // if (this.experiencesSw === 'Y') {
    //   this.isTests = true;
    // } else {
    //   this.isTests = false;
    // }
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Job Status', width: 140, field: 'jobStatusCd', editable: ((!(this.isDisabled || this.readOnly)) &&
          function (params) {
            const jobStatusCode = params.data.jobStatusCd;
            if (!params.api.gridCore.gridOptions.context.component.isDisabled) {
              if (jobStatusCode === 'Prior' && params.api.gridCore.gridOptions.context.component.isWorkHistoryLoded) {
                return false;
              } else {
                return true;
              }
            } else {
              return false;
            }
          }), cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: this.jobStatusArray,

        }, cellStyle: function (params) {
          if (params.api !== null) {
            const context = params.api.gridCore.gridOptions.context.component;
            if (context.isShowStyle && params.value === 'Pick an option') {
              return { border: '1px solid red' };
            } else {
              const that = params.api.gridCore.gridOptions;
              if (params.value === 'Current') {
                that.columnApi.getColumn('endDt').getColDef().editable = false;
                that.columnApi.getColumn('leftReasonCd').getColDef().editable = false;
                params.data.endDt = '';
                params.data.leftReasonCd = undefined;
                if (params.data.beginDt === '') {
                  params.data.beginDt = '';
                }

              } else {
                that.columnApi.getColumn('endDt').getColDef().editable = true;
                that.columnApi.getColumn('leftReasonCd').getColDef().editable = true;
                if (params.data.beginDt === '' || params.data.endDt === '') {
                  params.data.beginDt = '';
                }

              }

              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Employer', width: 140, field: 'employerName', cellEditor: 'textEditor',
        editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && (params.value === undefined || params.value.trim().length === 0)) {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Position', width: 140, field: 'position', editable: !(this.isDisabled || this.readOnly),
        cellEditor: 'textEditor', cellStyle: function (params) {
          // if (params.value === undefined || params.value.trim().length === 0) {
          //   return { border: '1px solid red' };
          // } else {
          //   return { border: 'none' };
          // }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },

      {
        headerName: ' Employer\'s Contact Info', width: 150, field: 'contactInfo', cellEditor: 'textEditor',
        editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {
          // if (params.value === undefined || params.value.trim().length === 0) {
          //   return { border: '1px solid red' };
          // } else {
          //   return { border: 'none' };
          // }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Hourly Salary', width: 140, field: 'hourlySalary', cellEditor: 'currencyEditor', valueFormatter: this.agGridUtility.formatAmount, editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {

          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && params.value === undefined) {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },

      {
        headerName: 'Start Date', width: 140, field: 'startDt', editable: !(this.isDisabled || this.readOnly),
        cellEditor: 'datePicker', cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if ((params.data.jobStatusCd === 'Prior' || params.data.jobStatusCd === 'Current') && (that.dateUtil.compareDate(params.value, new Date()) === 1 || params.value === undefined || params.value.trim().length === 0)) {

              return { border: '1px solid red' };

            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'End Date', width: 140, field: 'endDt', editable: !(this.isDisabled || this.readOnly),
        cellEditor: 'datePicker', cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (params.data.jobStatusCd === 'Prior' && (params.value === undefined || params.value.trim().length === 0 ||
              that.dateUtil.compareDate(params.value, new Date()) === 1)) {

              return { border: '1px solid red' };

            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Reason for Leaving', width: 140, field: 'leftReasonCd', editable: !(this.isDisabled || this.readOnly), cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: this.reasonLeavingArray,

        }, cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && (params.data.jobStatusCd === 'Prior'
              && (params.value === undefined || params.value === 'Pick an option'))) {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },

      {
        headerName: 'Action', width: 110, field: '', cellRenderer: this.getActionButtons,
        suppressFilter: true,
        suppressSorting: true
      },
    ];

    this.context = {
      component: this,
    };
    this.rowSelection = 'multiple';
    // this.components = { datePicker: this.getDatePicker() };
    this.frameworkComponents = {
      textEditor: TextEditor50Component,
      currencyEditor: CurrencyEditorComponent,
      datePicker: BootstrapDatePickerComponent
    };
    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === "Action") {
        return;
      }
      else {
        return nextCell;
      }
    }
  }

  getAuditColumnDefs() {
    this.auditColumnDefs = [
      {
        headerName: 'Modified By',
        field: 'createdBy',
        width: 195,
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 160,
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'Job Status',
        field: 'jobStatusCd',
        refData: this.jobStatusDescJson,
        width: 160,
        tooltip: (params) => {

          const jobStatusDescMap = params.context.jobStatusDescJson;
          const jobStatusCode = params.data.jobStatusCd;
          const jobStatus = jobStatusDescMap[jobStatusCode];
          return jobStatus;
        }
      },
      {
        headerName: 'Employer',
        field: 'employerName',
        width: 160,
        tooltipField: 'employerName'
      },
      {
        headerName: 'Position',
        field: 'position',
        width: 160,
        tooltipField: 'position'
      },
      {
        headerName: 'Employer&#39;s Contact Info',
        field: 'contactInfo',
        width: 160,
        tooltipField: 'contactInfo'
      },
      {
        headerName: 'Hourly Rate ',
        field: 'hourlySalary',
        valueFormatter: this.agGridUtility.formatAmount,
        width: 160,
        tooltip: this.agGridUtility.formatAmount
      },
      {
        headerName: 'Start Date',
        field: 'startDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 150,
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'End Date',
        field: 'endDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatDateCol,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 150,
        tooltip: this.agGridUtility.formatDateCol
      },
      {
        headerName: 'Reason for Leaving',
        field: 'leftReasonCd',
        refData: this.reasonLeavingJobDescJson,
        valueGetter: this.getReasonForLeaving,
        width: 160,
        tooltip: this.getReasonForLeaving
      }
    ];
    this.context = {
      component: this
    };
  }

  getReasonForLeaving(params) {
    if (params.data.leftReasonCd === null) {
      return `N/A`;
    }
    return params.data.leftReasonCd;
  }
  addEventListenerToSearch(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.workHistory.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }
  addEventListenerToAnswer(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.employmentHistory.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex1();
  }
  setDisplayedRowAtIndex1() {
    // get the first row
    var index = this.gridanswerApi.getFirstDisplayedRow();
    var rowNode = this.gridanswerApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridanswerApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridanswerApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridanswerApi.setFocusedCell(index, firstCol);
  }

  getDatePicker() {


    function Datepicker() { }
    Datepicker.prototype.init = function (params) {
      this.eInput = document.createElement('input');
      this.eInput.value = params.value;

      ($(this.eInput) as any).datepicker({
        dateFormat: 'mm/dd/yy',
        changeMonth: true,
        changeYear: true,
        firstDay: 1
      });
    };
    Datepicker.prototype.getGui = function () {
      return this.eInput;
    };
    Datepicker.prototype.afterGuiAttached = function () {
      this.eInput.focus();
      this.eInput.select();
    };
    Datepicker.prototype.getValue = function () {
      return this.eInput.value;
    };
    Datepicker.prototype.destroy = function () { };
    Datepicker.prototype.isPopup = function () {
      return false;
    };
    return Datepicker;
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridApi.columnDefs = this.columnDefs;
    } else {
      this.gridApi.sizeColumnsToFit();
    }
  }

  getActionButtons(params) {
    const that = params.context.component;

    const divRow = document.createElement('div');
    divRow.setAttribute('class', 'row justify-content-center');

    const element = document.createElement('a');
    if (that.isDisabled || that.readOnly) {
      element.setAttribute('class', 'disabled');
    }
    const image = DELETE_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.deleteTest();
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.deleteTest();
      }
      else if (event.keyCode == 9) {
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }

    });
    element.setAttribute("tabindex", "0");

    const divCol1 = document.createElement('div');
    divCol1.setAttribute('class', 'col-2 right-margin-1');

    divCol1.appendChild(element);

    // Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentWorkHistory');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Work History Audit');
      that.router.navigate(['/task/assessmentSummary/auditHistory']);
    });
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentWorkHistory');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Work History Audit');
        that.router.navigate(['/task/assessmentSummary/auditHistory']);
      }

    });
    auditElement.setAttribute("tabindex", "0");

    const divCol2 = document.createElement('div');
    divCol2.setAttribute('class', 'col-1');
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);

    return divRow;
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  }

  saveAll() {
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    this.isChangeDetected = false;
    let allWorkHistory = [];
    if (this.gridApi !== undefined) {
      this.gridApi.stopEditing();
      this.gridApi.selectAll();

      this.isShowStyle = true;
      this.gridApi.redrawRows();
      this.isShowStyle = false;

      allWorkHistory = this.gridApi.getSelectedRows();
      this.gridApi.deselectAll();
      this.validationError = [];
      this.showError = false;
      let errorIndex = 0;
      let isHeaderPushed = false;
      const employerNameArray = [];

      allWorkHistory.forEach(selectedRow => {
        ++errorIndex;
        let errorText = '';

        const employerName = selectedRow.employerName;
        if (!employerNameArray.includes(employerName)) {
          employerNameArray.push(employerName);
        } else {

          for (let index = 0; index < errorIndex - 1; index++) {
            if (allWorkHistory[index].employerName === employerName) {


              const existingWorkHistory = allWorkHistory[index];
              const startToStart = this.dateUtil.compareDate(selectedRow.startDt, existingWorkHistory.startDt);

              if (selectedRow.jobStatusCd === 'Prior') {

                const startLessEnd = this.dateUtil.compareDate(selectedRow.startDt, existingWorkHistory.endDt);
                const endToStart = this.dateUtil.compareDate(selectedRow.endDt, existingWorkHistory.startDt);


                if ((startToStart === -1 && endToStart === -1 && startLessEnd === -1)
                  ||
                  (startToStart === 1 && endToStart === 1 && startLessEnd === 1)) {
                  continue;
                } else {
                  this.validationError.push('Row ' + errorIndex + ': ' + ' dates overloaping for same employer at Row ' + (index + 1));
                  this.showError = true;
                }
              } else {
                const startLessEnd = this.dateUtil.compareDate(selectedRow.startDt, existingWorkHistory.endDt);

                if (startToStart === 1 && startLessEnd === 1) {
                  continue;
                } else {
                  this.validationError.push('Row ' + errorIndex + ': ' +
                    ' Current job start date must be greater than the prior job of same employer at Row ' + (index + 1));
                  this.showError = true;
                }
              }
            }
          }

        }


        if (selectedRow.jobStatusCd === undefined || selectedRow.jobStatusCd === 'Pick an option') {
          errorText = 'Job Status, ';
        } if (selectedRow.employerName === undefined || selectedRow.employerName.trim().length === 0) {
          errorText = errorText + 'Employer, ';
        }
        // } if (selectedRow.position === undefined || selectedRow.position.trim().length === 0) {
        //   errorText = errorText + 'Position, ';
        // } if (selectedRow.contactInfo === undefined || selectedRow.contactInfo.trim().length === 0) {
        //   errorText = errorText + 'Employer's Contact Info, ';
        // }
        if (selectedRow.hourlySalary === undefined) {
          errorText = errorText + 'Hourly Salary, ';
        } else if (parseFloat(selectedRow.hourlySalary) < 1 || parseFloat(selectedRow.hourlySalary) > 99.99) {
          this.validationError.push('Row ' + errorIndex + ': ' + 'Hourly Salary should be in between $1.00 and $99.99');
          this.showError = true;
        }

        if (selectedRow.startDt === "") {
          errorText = errorText + 'Start Date, ';
        } else if (selectedRow.jobStatusCd === 'Prior' && this.dateUtil.compareDate(selectedRow.startDt, new Date()) === 1) {
          this.validationError.push('Row ' + errorIndex + ': ' + 'Date Received should be current date or past date');
          this.showError = true;
        } else if (selectedRow.jobStatusCd === 'Prior' && this.dateUtil.compareDate(selectedRow.startDt, selectedRow.endDt) === 1) {
          this.validationError.push('Row ' + errorIndex + ': ' + 'End Date should be greater than Start Date');
          this.showError = true;
        }
        if (selectedRow.jobStatusCd === 'Prior' && (selectedRow.endDt === undefined || selectedRow.endDt === "")) {
          errorText = errorText + 'End Date, ';
        } else if (selectedRow.jobStatusCd === 'Prior' && (this.dateUtil.compareDate(selectedRow.endDt, new Date()) === 1)) {
          this.validationError.push('Row ' + errorIndex + ': ' + 'End Date should be Current Date or Prior Date');
          this.showError = true;
        }

        if (selectedRow.endDt === 'Prior' && (selectedRow.endDt === undefined)) {
          errorText = errorText + 'Start Date, ';
        }
        if (selectedRow.jobStatusCd === 'Prior' &&
          (selectedRow.leftReasonCd === undefined || selectedRow.leftReasonCd === 'Pick an option')) {
          errorText = errorText + 'Reason for Leaving, ';
        }

        if (errorText.length > 0) {
          if (!isHeaderPushed) {
            isHeaderPushed = true;
            this.validationError.push('Following fields are mandatory:');
          }
          errorText = errorText.substring(0, errorText.length - 2);
          this.validationError.push('Row ' + errorIndex + ': ' + errorText);
          this.showError = true;
        }
      });
    }
    if (!this.showError) {

      this.removedWorkHistory.forEach(element => {
        allWorkHistory.push(element);
      });
      allWorkHistory.forEach(selectedRow => {
        selectedRow.jobStatusCd = this.jobStatusDescReverseJson[selectedRow.jobStatusCd];
        selectedRow.leftReasonCd = this.reasonLeavingJobDescReverseJson[selectedRow.leftReasonCd];
        selectedRow.startDt = this.dateUtil.convertFormattedDateForServer(selectedRow.startDt);
        selectedRow.endDt = this.dateUtil.convertFormattedDateForServer(selectedRow.endDt);
      });
      this.assessment.jobExperienceSw = this.experiencesSw;
      this.assessment.empSecurityDeptSw = this.empSecuritySw;
      this.assessment.empRegistrationSw = this.employmentSw;
      if (this.experiencesSw === 'N' || (this.experiencesSw === 'Y' && (allWorkHistory.length > 0))) {

        this.employmenTask = undefined;
        if (this.experiencesSw === 'Y' && (allWorkHistory.length > 0)) {
          this.createEmpChangeTask();
        }

        const request = new RequestLoadAll(allWorkHistory, this.assessment, this.employmenTask);
        this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/saveWorkHistory', request).subscribe(
          (data) => {
            if (data.hasOwnProperty('errorCode')) {
              this.notificationService.error('Assessment-Work History', this.userActionNotificationsMap.ERROR);
            } else {
              this.isChangeDetected = false;
              this.notificationService.success('Assessment-Work History', this.userActionNotificationsMap.ADD);
              this.notificationService.warn('Assessment-Work History', 'This is a non-actionable task and will not be sent to ARIES.');
              if (this.assessmentId > 0) {

                this.load(new RequestLoad(this.assessmentId));
                this.removedWorkHistory = [];

              }
            }
          }, response => {

            this.notificationService.error('Assessment-Work History', this.userActionNotificationsMap.ERROR);
          }, () => {

          });
      } else {
        this.notificationService.warn('Assessment-Work History', 'Please add atleast one Work History record ');
      }
    }
  }


  finalizeAssessment() {


    if (this.assessment.highestEducationCd === null) {

      this.notificationService.warn('Finalize Assessment',
        'Assessment cannot be finalized until all forms have been completed. Review the Education & Certifications page');

    } else if (this.assessment.skillSw === null) {
      this.notificationService.warn('Finalize Assessment',
        'Assessment cannot be finalized until all forms have been completed. Review the Skills & Strengths page');

    } else if (this.assessment.testScoreSw === null) {
      this.notificationService.warn('Finalize Assessment',
        'Assessment cannot be finalized until all forms have been completed. Review the Tests & Scores page');

    } else if (this.assessment.familyBarrierSw === null) {
      this.notificationService.warn('Finalize Assessment',
        'Assessment cannot be finalized until all forms have been completed. Review the Barriers page');

    } else if (this.assessment.jobExperienceSw === null) {
      this.notificationService.warn('Finalize Assessment',
        'Assessment cannot be finalized until all forms have been completed. Review the Work History page');

    } else {
      const assessmentFinal = new AssessmentSummary(this.assessment.programCd, this.assessment.etEnrollmentId, this.assessment.statusCd
      );
      assessmentFinal.id = this.assessment.id;



      const referralId = this.sharedData.get('referralId');

      const providerId = this.sharedData.get('providerId');

      let indicator = 'C';
      let assignedTo = 0;
      if (providerId > 0) {
        assignedTo = providerId;
        indicator = 'P';
      } else {
        const personProvider = this.sharedData.get('personProvider');
        if (personProvider !== undefined && personProvider != null && personProvider.id !== undefined) {
          assignedTo = personProvider.id.serviceCounty;
        }
      }

      const wpPerson = new WpPerson();
      wpPerson.id = this.personId;
      const wpReferral = new WpReferral();
      wpReferral.id = Number(referralId);

      const oldTask = new Task();

      oldTask.assignedTo = String(assignedTo);
      oldTask.assignedToInd = indicator;
      oldTask.taskType = 'PA';
      oldTask.wpReferral = wpReferral;
      oldTask.wpPerson = wpPerson;

      const newTask = Object.assign({}, oldTask);
      newTask.taskType = 'EP';
      newTask.programCd = assessmentFinal.programCd;

      const assessmentRequestVO = new RequestVO(assessmentFinal, newTask, oldTask);

      this.http.post<AssessmentSummary>(this.serverConstants.SERVER_API_URL + '/assessment-summary/save/Final',
        assessmentRequestVO).subscribe(
          (data) => {
            if (data.hasOwnProperty('errorCode')) {
              this.notificationService.error('Finalize Assessment', this.userActionNotificationsMap.ERROR);
            } else {
              if (data !== undefined) {

                this.notificationService.success('Finalize Assessment', this.userActionNotificationsMap.ADD);
                this.router.navigate(['task/assessmentSummary']);
              }
            }
          }, response => {

            this.notificationService.error('Finalize Assessment', this.userActionNotificationsMap.ERROR);
          }, () => {

          });
    }

  }
  onGridAnswerReady(params) {
    this.gridanswerApi = params.api;
    params.api.sizeColumnsToFit();
    params.api.setGridAutoHeight(true);
  }


  getColumnDefinitionsAnswer() {
    this.answersColumnDefs = [
      { headerName: 'Employer Name', field: 'EMPLOYER_NAME' },
      { headerName: 'Employment Type', field: 'EMPLOYMENT_TYPE' },
      { headerName: 'Begin Date', width: 140, field: 'START_DT' },
      { headerName: 'End Date', width: 140, field: 'END_DT' }

    ];


  }


  load(request) {
    this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/loadObjects/work-history', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Assessment-Work History', this.userActionNotificationsMap.ERROR);
        } else {
          if (data !== null && data !== undefined && data.workHistory !== undefined) {
            this.workHistory = data.workHistory;
            this.workHistory.forEach(selectedRow => {
              selectedRow.jobStatusCd = this.jobStatusDescJson[selectedRow.jobStatusCd];
              selectedRow.leftReasonCd = this.reasonLeavingJobDescJson[selectedRow.leftReasonCd];
              selectedRow.startDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.startDt);
              selectedRow.endDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.endDt);
            });
            this.isWorkHistoryLoded = true;
          } else {
            this.workHistory = [];

          }
          if (data !== null && data !== undefined && data.assessment !== undefined) {
            this.assessment = data.assessment;
            if (this.assessment.statusCd !== undefined && (this.assessment.statusCd === 'CO') || (this.assessment.statusCd === 'CN')) {
              this.isDisabled = true;
              this.tabIndex = '0';
              this.getColumnDefinitions();
            }
            this.experiencesSw = this.assessment.jobExperienceSw;
            this.empSecuritySw = this.assessment.empSecurityDeptSw;
            this.employmentSw = this.assessment.empRegistrationSw;
            this.removedWorkHistory = [];
            if (this.experiencesSw === 'Y') {
              this.show = true;
            } else {
              this.show = false;
            }
          }



        }

        this.validationError = [];
        this.showError = false;
      }, response => {

        this.notificationService.error('Assessment-Work History', this.userActionNotificationsMap.ERROR);
      }, () => {

      });



  }

  loadAnswerData() {
    const ssnValue = this.sharedData.get('SSN_SEARCH');

    this.http.get<EmploymentHistory[]>(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetClientEmploymentHistory/'
      + ssnValue).subscribe(
        (data: EmploymentHistory[]) => {
          if (data !== null && data !== undefined && data.length > 0) {
            this.employmentHistory = data;
            this.employmentHistory.sort((a, b) => new Date(b.START_DT).getTime() - new Date(a.START_DT).getTime());
            this.employmentHistory.forEach(rows => {
              if (rows.START_DT !== undefined && rows.START_DT !== null) {
                rows.START_DT = this.dateUtil.formatDateMDY(rows.START_DT);
              }
              if (rows.END_DT !== undefined && rows.END_DT !== null) {
                rows.END_DT = this.dateUtil.formatDateMDY(rows.END_DT);
              }
            });
          } else {
            // US# 19_01 | Story ID	19_01 | Story Title		Work Requirement - Yellow Toast Notifications | POIGAI
            // The existing yellow toast notification to be removed so commented the below
            // this.notificationService.warn('Assessment-Work History', 'Employment History Information not found in ANSWER');
            this.employmentHistory = [];
          }
        },
        response => {
          this.notificationService.error('Assessment-Work History', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });

  }

  loadAriesData() {
    const value = this.sharedData.get('personProvider').emciId;

    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/Aries/empInfo/'
      + value).subscribe(
        (data: Array<Object>) => {
          if(data.length > 0){
            let empList=[];
            data.forEach((element)=>{
              let record = {
                EMPLOYER_NAME:null,
                EMPLOYMENT_TYPE:null,
                START_DT:null,
                END_DT:null
              }
              if(element["employer"] != null){
                record.EMPLOYER_NAME = element["employer"];
              }
              /*if(element["EMP_TYPE"] != null && this.loginService.staticData.get("EmploymentType").find(obj => obj.value == element["EMP_TYPE"]) != undefined){
                record.employmentType = this.loginService.staticData.get("EmploymentType").find(obj => obj.value == element["EMP_TYPE"]).name;
              }
              else{
                record.employmentType = element["EMP_TYPE"];
              }*/
              if(element["effBeginDt"] != null){
                // record.employmentStartdate = element["EMP_START"].toString().split(" ")[0];
                record.START_DT= this.datePipe.transform(new Date(element["effBeginDt"]), 'MM/dd/yyyy');
              }
              if(element["effEndDate"] != null){
                //record.employmentEnddate = element["EMP_END"].toString().split(" ")[0];
                record.END_DT= this.datePipe.transform(new Date(element["effEndDate"]), 'MM/dd/yyyy');
              }
              if(record.EMPLOYER_NAME != null){
                empList.push(record);
              }
                      
            })
            this.employmentHistory = empList
          }else {
            // US# 19_01 | Story ID	19_01 | Story Title		Work Requirement - Yellow Toast Notifications | POIGAI
            // The existing yellow toast notification to be removed so commented the below
            // this.notificationService.warn('Assessment-Work History', 'Employment History Information not found in ANSWER');
            this.employmentHistory = [];
          }
        },
        response => {
          this.notificationService.error('Assessment-Work History', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });

  }
  reset() {
    if (this.assessmentId > 0) {

      this.load(new RequestLoad(this.assessmentId));

    }
  }

  addTests() {
    const response = this.gridApi.updateRowData({
      add: [new WorkHistory(this.assessment, 'N', '', '')]
    });
    let index;
    response.add.forEach(element => {
      index = element.rowIndex;
    });
    this.gridApi.setFocusedCell(index, 'jobStatusCd');
    this.gridApi.startEditingCell({
      rowIndex: index,
      colKey: 'jobStatusCd'
    });
  }
  deleteTest() {
    const selectedData = this.gridApi.getSelectedRows();
    this.gridApi.updateRowData({ remove: selectedData });

    selectedData.forEach(element => {
      if (element.id > 0) {
        element.deleteSw = 'Y';
        this.removedWorkHistory.push(element);
      }

    });
  }


  createEmpChangeTask() {

    this.employmenTask = new Task();
    this.employmenTask.wpPerson = new WpPerson();
    this.employmenTask.wpPerson.id = Number(this.personId);
    this.employmenTask.wpReferral = new WpReferral();
    this.employmenTask.wpReferral.id = Number(this.referralId);
    this.employmenTask.programCd = 'FS';
    this.employmenTask.taskStatus = 'OP';
    this.employmenTask.assignedTo = this.serviceCountyForPerson.toString();
    this.employmenTask.assignedToInd = 'C';
    this.employmenTask.taskType = 'EC';
  }
}


class RequestLoad {
  constructor(
    public id: Number,

  ) {
  }
}

class WorkHistory {
  constructor(
    public assessment: AssessmentSummary,
    public deleteSw: String,
    public startDt: any,
    public endDt?: any,
    public jobStatusCd?: string,
    public employerName?: string,
    public hourlySalary?: any,

    public contactInfo?: String,
    public position?: String,
    public leftReasonCd?: string,
    public id?: any,
    public recordVersion?: number

  ) {
  }
}

class RequestLoadAll {
  constructor(
    public workHistory: any,
    public assessment: AssessmentSummary,
    public empChangeTask: Task
  ) {
  }
}
class PersonWorkHistoryAnswer {
  constructor(
    public employerName: string,
    public employmentType: string,
    public startDt: any,
    public endDt: any
  ) {
  }
}




// WEBPACK FOOTER //
// ./src/app/work-history/work-history.component.ts